import { HttpResponse, http } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import {
    type GetChargingStationMetadataListApiResponse,
    TruckClassification as TruckClassificationV3,
} from '../../../src/store/facade/facadeApiV3';

const URL_V3 = `${BASE_URL_V3}${API.endpoints.chargingStations}${API.endpoints.metadata}`;

export const PostSearchStationsMetadataHandler = http.post(URL_V3, async () => {
    return HttpResponse.json({
        hasMore: false,
        chargingStations: [chargePointData1Metadata, chargePointData2Metadata],
    } as GetChargingStationMetadataListApiResponse);
});

export const PostSearchStationsMetadataErrorHandler = http.post(URL_V3, async () => {
    return HttpResponse.error();
});

export const chargingStationsMetadataResource = {
    success: PostSearchStationsMetadataHandler,
    error: PostSearchStationsMetadataErrorHandler,
};

export const chargePointData1Metadata = {
    id: '07765f10-d848-40eb-953f-e81878bd34c9',
    name: 'DE | Aral 0F150 | Bahnhofstraße 53, 55494 Rheinböllen | TRUCK - DC #02',
    tcsId: 'tcs-uu-id',
    hereId: undefined,
    operator: {
        id: '2aefcdfb-b632-420b-85af-c5c07b3e6322',
        name: 'BP Europa SE',
    },
    location: {
        latitude: 49.996284,
        longitude: 7.683968,
    },
    address: {
        street: 'Bahnhofstraße 53',
        city: 'Rheinböllen',
        postalCode: '55494',
        countryCode: 'DE',
        region: '',
    },
    maxPower: 300,
    truckClassification: TruckClassificationV3.TruckReady,
    numberOfConnectors: 2,
    connectorsPowers: [100, 400],
};

export const chargePointData2Metadata = {
    id: '430c2be9-b6ea-44fc-bd4b-fceadb204b39',
    name: 'Proviridis/6426d2f8e68d7362559e5b6f',
    tcsId: 'tcs-uu-id',
    hereId: undefined,
    operator: {
        id: '83f23926-43ae-4e43-8b3c-d2ad60cc1fb8',
        name: 'Proviridis',
    },
    location: {
        latitude: 46.228058,
        longitude: 5.259945,
    },
    address: {
        street: 'Impasse des Bois de Tharlet',
        city: 'Viriat',
        postalCode: '01440',
        countryCode: 'FR',
        region: '',
    },
    maxPower: 300,
    truckClassification: TruckClassificationV3.TruckLimited,
    numberOfConnectors: 6,
    connectorsPowers: [100, 300, 300, 300, 300, 400],
};
